// lib/parseLink

export default function (name = null, parseLink = null) {
  return function (number, date) {

    if(number) number = number.trim()
    var link = parseLink + '/' + number
    var data = {}

    data.name = name
    if (number) data.number = number
    if (date)   data.date = date

    data = JSON.stringify(data)
    return `<a data-data='${data}' href="${link}">${number}</a>`
  }

}



/** WEBPACK FOOTER **
 ** ./src/js/lib/filters/parseLink.js
 **/